import { loadSelect } from '@/api/common.js'
// 加载校区下拉框
export function loadXiaoQuSelect (data) {
  loadSelect({ url: '/api/v2/pdp/xiaoqu/list', data: data, order: 'xqmc', sort: 'asc' }) // [url]接口地址 [data]列表
}